import API from '../modules/api';
const api = new API({ authStoreKey: 'addsearch' });
import Mustache from 'mustache';

const input = document.querySelector('.js-addsearch');
const submit = document.querySelector('.js-addsearch-submit');
const template = document.querySelector('.template-addsearch');
const list = document.querySelector('.js-addsearch-list');
const showallButton = document.querySelector('.js-addsearch-showall');

const PARAMS = {
  keyword: null,
  showAll: false
}

export default class AddSearch {
  constructor() {
  }

  /**
   * Initialize
   */
  init() {
    input.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        this.getResults();
      }
    });
    submit.addEventListener('click', () => { this.getResults(); } );
    showallButton.addEventListener('click', () => {
      PARAMS.showAll = true;
      showallButton.style.display = 'none';
      this.getResults();
    });
  }

  /**
   * Get search results for keyword
   */
  getResults() {
    PARAMS.keyword = input.value;
    api.getSearchResults(PARAMS).then(data => {
      this.render(data);
    });
  }

  /**
   * Render results as html to page
   * @param {array} data array from API
   */
  render(data) {

    if (data?.result) {
      data = data.result;

      if (data.total_hits > 9 && !PARAMS.showAll) {
        data.hits.products = data.hits.products.slice(0, 3);
        data.hits.blog = data.hits.blog.slice(0, 3);
        data.hits.contact = data.hits.contact?.slice(0, 3);
        data.hits.other = data.hits.other.slice(0, 3);

        showallButton.style.display = 'inline-block';
      }
      else {
        showallButton.style.display = 'none';
      }

      list.innerHTML = Mustache.render(template.innerHTML, { data, ...PARAMS });
    }
  }
}

const addsearch = new AddSearch();
addsearch.init();
